<template>
    <div class="notice_details" v-if="content.id">
        <div class="content">
            <div class="bt"><span>{{content.title}}</span><span class='rig'>{{jqtime(content.createTime)}}</span></div>
            <div class="fwb" v-html=content.content></div>
        </div>
    </div>
</template>
<script>
//当前实例组件

export default {

  data: () => ({
      id:'',
      content:{}
  }),
  components: {

  },
  created() {
    this.id = this.$route.params.id;
    this.getcontent(this.id);
  },
  methods: {
    getcontent:function(id){
        this.$http({
            url: '/master/mechanIndex/read/msg',
            type: 'put',
            params:{
                id:id
            },
        }).then((data)=> {
            if(data.data.url){
                location.replace(data.data.url);
                return;
            }
            this.content = data.data;
        })
    },
    jqtime: function(time) {
      if (time) {
        return this.$tools.formatDate(time,"yyyy/MM/dd hh:mm");
      }
    },
  },
  mounted() {

  }
};
</script>
<style lang="scss">
.notice_details{
    .title{
        padding:15px 40px;
        background: #fff;
        i{
            display: inline-block;
            width: 4px;
            height: 16px;
            vertical-align: middle;
            background: #ff9700;
        }
        span{
            font-size: 16px;
            vertical-align: middle;
            margin-left: 5px;
        }
    }
    .content{
        padding: 15px 40px;
        background: #fff;
        .bt{
            border-bottom:1px solid #f5f5f5;
            line-height:40px;
            text-align: center;
            overflow:hidden;
            span{
                font-weight: 700;
                font-size: 18px;
            }
           .rig{
               float:right;
                font-size: 16px;
                font-weight: 400;
           }
        }
        .fwb{
            margin-top: 20px;
            line-height:1.75;
            font-size:16px;
            img{
                max-width:100%;
            }
            a{
                color:#409EFF;
            }

        }
    }
}
</style>
